module.exports = __webpack_public_path__ + "static/media/StrengthsIdentification.e095908f.png";